module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-wacana"
    }
  }, [_c('div', [(_vm.wacana.id != 0) ? _c('blockquote', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewWacana)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "outlined": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateWacanaModal = true
      }
    }
  }, [_vm._v("Buat Baru")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "outlined": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Pilih")]), _vm._v(" "), (_vm.wacana.id != 0) ? _c('v-btn', {
    staticClass: "blew--text",
    attrs: {
      "color": "touchBlue",
      "elevation": "0"
    },
    on: {
      "click": _vm.editWacana
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.wacana.id != 0) ? _c('v-btn', {
    staticClass: "redLight--text",
    attrs: {
      "color": "touchRed",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmation = true
      }
    }
  }, [_vm._v("Hapus")]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px"
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticClass: "d-flex align-center justify-space-between"
        }, [_c('span', [_vm._v("Cari Wacana")]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-center mt-2",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('div', {
          staticClass: "mt-3 px-1",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('v-text-field', {
          staticClass: "mx-4",
          staticStyle: {
            "width": "calc(100% - 32px)"
          },
          attrs: {
            "placeholder": "Cari isi wacana",
            "append-icon": "mdi-magnify",
            "hide-details": "",
            "outlined": "",
            "clearable": ""
          },
          on: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.loadData.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.searchValue),
            callback: function($$v) {
              _vm.searchValue = $$v
            },
            expression: "searchValue"
          }
        })], 1), _vm._v(" "), (_vm.isLoading) ? _c('v-progress-circular', {
          staticClass: "ml-2",
          attrs: {
            "indeterminate": "",
            "size": "22"
          }
        }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-text', [_c('app-datatable', {
          attrs: {
            "hideSearch": true,
            "items": _vm.wacanas,
            "headers": _vm.headers,
            "hasAction": true,
            "custom-pagination-current-page": 1,
            "custom-pagination-per-page": 10,
            "hideTop": true
          },
          on: {
            "dblClicked": function($event) {
              _vm.wacana = {
                id: $event.id,
                content: $event.isi
              };
              _vm.showModal = false;
            }
          }
        })], 1), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), (_vm.showConfirmation) ? _c('app-modal', {
    on: {
      "ok": _vm.resetWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Perhatian")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v("Apakah anda yakin ingin melepas wacana ini dari soal?")])])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "675px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showCreateWacanaModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', [_vm._v("Buat Wacana Baru")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
          staticClass: "pa-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('app-editor', {
          attrs: {
            "value": _vm.wacana.content,
            "hasUpload": true,
            "title": "Wacana"
          },
          on: {
            "content-updated": function($event) {
              _vm.wacana.content = $event
            }
          }
        })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": "",
            "elevation": "0"
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Batal")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "dark": "",
            "color": "blew"
          },
          on: {
            "click": function($event) {
              return _vm.saveWacana()
            }
          }
        }, [_vm._v("Simpan")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showCreateWacanaModal),
      callback: function($$v) {
        _vm.showCreateWacanaModal = $$v
      },
      expression: "showCreateWacanaModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba460a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/itembank/components/Wacana.vue
// module id = 1551
// module chunks = 1